import React from "react"
import { AppDialog } from "@components"
import { isOpenInfoModal } from "Pages/ReportsAlerts/Reports/@signals"
import ReportInfoModalContent from "Pages/ReportsAlerts/Reports/@components/InfoModal/Content"


export default function ReportInfoModal() {

	const onClose = () => isOpenInfoModal.value = null

	return <AppDialog
		open={!!isOpenInfoModal.value}
		onClose={onClose}
		maxWidth="lg"
	>
		<ReportInfoModalContent onClose={onClose}/>
	</AppDialog>
}
